import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, PAYMENT, slDateTime } from "@/lib/api";
import { inputCls } from "@/pages/Login";

export default function AdminWeddingPanel({ wedding, onSaved }) {
  const [pkgs, setPkgs] = useState([]);
  const [gb, setGb] = useState(5);
  const [note, setNote] = useState(wedding.admin_note || "");
  const [amount, setAmount] = useState(wedding.amount_paid ?? "");
  const [tables, setTables] = useState(wedding.table_count || 0);
  const [voiceMax, setVoiceMax] = useState(wedding.voice_max_seconds || 60);
  const [log, setLog] = useState([]);
  useEffect(() => {
    api.get("/admin/packages").then((r) => setPkgs(r.data));
    api.get("/admin/audit", { params: { wedding_id: wedding.id } }).then((r) => setLog(r.data));
  }, [wedding.id]);

  const save = async (body, msg = "Shranjeno.") => {
    try { await api.patch(`/admin/weddings/${wedding.id}`, body); toast.success(msg); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  const ship = wedding.shipping;

  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="admin-wedding-panel">
      <div className="card-lux p-6 space-y-5">
        <h3 className="font-display text-2xl">Plačilo in paket</h3>
        <div className="flex flex-wrap gap-2">
          {Object.entries(PAYMENT).map(([k, l]) => (
            <button key={k} onClick={() => save({ payment_status: k }, k === "placano" ? "Plačilo potrjeno, galerija aktivirana." : "Shranjeno.")} className={`px-4 py-2 rounded-full text-sm border ${wedding.payment_status === k ? "bg-[#231F20] text-white" : "border-[#DFD5C5]"}`} data-testid={`admin-payment-${k}`}>{l}</button>
          ))}
        </div>
        <label className="block text-sm text-[#6C6560]">Paket
          <select className={`${inputCls} mt-1`} value={wedding.package_id} onChange={(e) => save({ package_id: e.target.value })} data-testid="admin-package-select">
            {pkgs.map((p) => <option key={p.id} value={p.id}>{p.name} · {p.price} €{p.per_table_price ? ` + ${p.per_table_price} €/miza` : ""}</option>)}
          </select>
        </label>
        <div className="flex gap-2 items-end">
          <label className="block text-sm text-[#6C6560] flex-1">Število miz<input type="number" min="0" max="80" className={`${inputCls} mt-1`} value={tables} onChange={(e) => setTables(e.target.value)} data-testid="admin-tables-input" /></label>
          <button onClick={() => save({ table_count: Number(tables) })} className="btn-line px-4 h-12 text-sm" data-testid="admin-tables-save">Shrani</button>
        </div>
        <p className="text-sm" data-testid="admin-order-total">Vrednost naročila: <b>{wedding.order_total ?? "—"} €</b></p>
        <div className="flex gap-2 items-end">
          <label className="block text-sm text-[#6C6560] flex-1">Plačani znesek (€)<input type="number" step="0.01" className={`${inputCls} mt-1`} value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="admin-amount-input" /></label>
          <button onClick={() => save({ amount_paid: Number(amount) })} className="btn-line px-4 h-12 text-sm" data-testid="admin-amount-save">Shrani</button>
        </div>
        <p className="text-xs text-[#6C6560]">Aktivirano: {wedding.activated_at ? slDateTime(wedding.activated_at) : "še ne"}</p>
      </div>
      <div className="card-lux p-6 space-y-5">
        <h3 className="font-display text-2xl">Shramba</h3>
        <div className="flex gap-2 items-end">
          <label className="block text-sm text-[#6C6560] flex-1">Dodaj prostor (GB)<input type="number" min="1" className={`${inputCls} mt-1`} value={gb} onChange={(e) => setGb(e.target.value)} data-testid="admin-storage-input" /></label>
          <button onClick={() => save({ add_storage_gb: Number(gb) }, "Prostor je povečan.")} className="btn-dark px-4 h-12 text-sm" data-testid="admin-storage-add">Dodaj</button>
        </div>
        <button onClick={() => save({ add_years: 1 }, "Hramba je podaljšana za 1 leto.")} className="btn-line px-5 py-2.5 text-sm" data-testid="admin-extend-year">Podaljšaj hrambo za 1 leto</button>
        <p className="text-xs text-[#6C6560]">Dodatna leta: {wedding.extra_years || 0}</p>
        <div className="flex gap-2 items-end">
          <label className="block text-sm text-[#6C6560] flex-1">Najdaljše glasovno sporočilo (s)<input type="number" min="10" max="300" className={`${inputCls} mt-1`} value={voiceMax} onChange={(e) => setVoiceMax(e.target.value)} data-testid="admin-voice-max-input" /></label>
          <button onClick={() => save({ voice_max_seconds: Number(voiceMax) })} className="btn-line px-4 h-12 text-sm" data-testid="admin-voice-max-save">Shrani</button>
        </div>
      </div>
      <div className="card-lux p-6 space-y-3">
        <h3 className="font-display text-2xl">Dostava in opombe</h3>
        {ship ? <p className="text-sm" data-testid="admin-shipping">{ship.name}<br />{ship.address}<br />{ship.postal_code} {ship.city}{ship.phone && <><br />{ship.phone}</>}</p> : <p className="text-sm text-[#6C6560]">Brez fizičnih izdelkov ali naslova.</p>}
        <textarea rows={3} className={`${inputCls} h-auto py-3`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Interna opomba" data-testid="admin-note-input" />
        <button onClick={() => save({ admin_note: note })} className="btn-line px-5 py-2 text-sm" data-testid="admin-note-save">Shrani opombo</button>
      </div>
      <div className="card-lux p-6 space-y-2 max-h-96 overflow-y-auto">
        <h3 className="font-display text-2xl mb-2">Revizijski dnevnik</h3>
        {log.map((l) => <p key={l.id} className="text-xs text-[#6C6560]"><span className="text-[#231F20]">{l.action}</span> · {l.actor} · {slDateTime(l.created_at)}</p>)}
      </div>
    </div>
  );
}
